import axios, { AxiosResponse } from 'axios';
import { FileSummary } from 'views/sea-cloud-file-upload/types/file-summary.type';

// GET
// Returns summary information from latest uploaded file that was not imported yet.
// /ewosapi/v1/SeaCloudFileUpload/{globalCompanyId}
export const getSeaCloudFileSummary = async (globalCompanyId: string): Promise<FileSummary> => {
  const res = await axios.get<FileSummary>(`/ewosapi/v1/SeaCloudFileUpload/${globalCompanyId}`);
  return res.data;
};

// GET
// Download File from SeaCloud.
// /ewosapi/v1/SeaCloudFileUpload/{globalCompanyId}/{fileId}
export const getSeaCloudFileDownload = async (globalCompanyId: string, fileId: number): Promise<AxiosResponse> => {
  return await axios.get<AxiosResponse>(`/ewosapi/v1/SeaCloudFileUpload/${globalCompanyId}/${fileId}`, {
    responseType: 'blob',
  });
};
